"use strict";
/**
 * GSAP conditional loading
 * Only loads GSAP + ScrollTrigger if elements with [data-gsap] exist on the page
 *
 * @package StandOut
 * @since 2.0.0
 */
document.addEventListener("DOMContentLoaded", () => {
    const gsapElements = document.querySelectorAll("[data-gsap]");
    if (gsapElements.length > 0) {
        import("gsap")
            .then(({ gsap }) => {
            return Promise.all([
                import("gsap/ScrollTrigger"),
                import("gsap/ScrollToPlugin"),
                import("gsap/SplitText"),
            ]).then(([{ ScrollTrigger }, { ScrollToPlugin }, { SplitText }]) => {
                gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, SplitText);
                window.SplitText = SplitText;
                window.gsap = gsap;
                window.ScrollTrigger = ScrollTrigger;
                const event = new CustomEvent("gsap-loaded", {
                    bubbles: true,
                });
                window.dispatchEvent(event);
            });
        })
            .catch((error) => {
            console.error("Failed to load GSAP:", error);
        });
    }
});
